<template>
  <v-combobox
    v-model="selected"
    :item-value="itemValue"
    :item-text="itemText"
    :items="options"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    clearable
    @change="change($event)"
    ref="input"
  />
</template>

<script>
export default {
  name: 'FacilityCombobox',
  emits: ['input'],
  $_veeValidate: {
    name () {
      return this.label
    },
    value () {
      return this.selectedFacility
    }
  },
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    itemText: {
      type: String,
      default: 'name'
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selected: { id: 0, name: this.getExpression('Alert', 'NoFacility') },
      noSelection: { id: 0, name: this.getExpression('Alert', 'NoFacility') }
    }
  },
  computed: {
    selectedId () {
      return this.value
    }
  },
  methods: {
    change (e) {
      const value = e !== undefined
        ? e.id
        : 0
      this.$emit('input', value)
    },
    
    setValue () {
      const self = this
      const facilities = this.options.filter(o => o.id === self.selectedId)
      self.selected = facilities.length > 0
        ? facilities[0]
        : self.placeholder != null
          ? null
          : self.noSelection
    },

    focus () {
      this.$refs.input.focus()
    }

  },
  watch: {
    selectedId () {
      this.setValue()
    }
  }
}
</script>